import { Link } from "react-router-dom";
import RichContent from "@/components/RichContent";
import { useQuery } from "@tanstack/react-query";
import { FileText, ShieldCheck, Accessibility } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";
import api from "@/lib/api";

const EXTRA = [
  { title: "Accessibility Statement", body: "Enhancing Your World is committed to accessibility. We design for readable fonts, sufficient color contrast, keyboard navigation, alt text, accessible forms, and screen-reader-friendly components across the website and mobile app. If you encounter a barrier, please contact us via the Contact page and we will work to resolve it." },
];

export default function Policies() {
  const { data: agreements = [] } = useQuery({ queryKey: ["agreements"], queryFn: () => api.get("/agreements").then((r) => r.data) });
  const policyTypes = ["privacy", "terms", "member", "pma", "ministry"];
  const policies = agreements.filter((a) => policyTypes.includes(a.type));

  return (
    <div data-testid="policies-page">
      <Seo title="Policies & Legal" description="Privacy, terms, cancellation and refund policies, membership agreements and privacy requests for Enhancing Your World." />
      <PageHero label="Trust & Compliance" title="Policies & legal." subtitle="Our commitment to transparency, consent, privacy, and clear agreements. Review our policies and manage your data anytime." testid="policies-hero" />
      <section className="max-w-3xl mx-auto px-6 py-16 space-y-4">
        <div className="flex flex-wrap gap-3 mb-6">
          <Link to="/agreements" className="eyw-btn !py-2 text-sm"><FileText size={15} /> Agreements</Link>
          <Link to="/data-request" className="eyw-btn-ghost !py-2 text-sm"><ShieldCheck size={15} /> Make a Privacy Request</Link>
        </div>
        {policies.map((p) => (
          <details key={p.id} data-testid={`policy-${p.id}`} className="eyw-card p-6">
            <summary className="cursor-pointer text-lg text-[#1A242B] flex items-center gap-2"><FileText size={16} className="text-[#144F75]" /> {p.title}</summary>
            <RichContent text={p.content} className="text-sm text-[#4A5D6B] mt-3 leading-relaxed" />
          </details>
        ))}
        {EXTRA.map((p) => (
          <details key={p.title} className="eyw-card p-6">
            <summary className="cursor-pointer text-lg text-[#1A242B] flex items-center gap-2"><Accessibility size={16} className="text-[#144F75]" /> {p.title}</summary>
            <p className="text-sm text-[#4A5D6B] mt-3 whitespace-pre-line leading-relaxed">{p.body}</p>
          </details>
        ))}
        <p className="text-xs text-[#8FA89B] pt-4">All legal, tax, PMA, ministry, wellness, and privacy language should be reviewed by qualified professionals before launch.</p>
      </section>
    </div>
  );
}
